import * as gateData from "../data/gates";
import LocalStorageHelper from "./localStorageHelper";
import { environment } from "../data/config";

// ============================================================================
// TIMEX Helpers
// ============================================================================

export const GetGates = (station) => {
    let allGates = [];
    var gateFilter = gateData.gates.filter((gates) => {
        return gates.station.includes(station);
    });

    if (gateFilter.length > 0) {
        allGates = gateFilter[0].ids;
    }

    return allGates;
};

export const IsLoggedIn = () => {
    let user = LocalStorageHelper.getUser();
    if (user && user.token) {
        return true;
    }
    return false;
};

export const GetDefaultFlightFilters = (selectedStation = "YTZ") => ({
    gateFilters: [],
    hourFilter: environment.maxTimeWindow ?? 1,
    aircraftFilters: [],
    flightOrTailNumberSearch: null,
});

export const IsHeadStart = (flightDetails) => {
    return flightDetails.LegHashKeyInbound == null && flightDetails.TerminatorFlight == 0
}


export const IsTerminatorFlight = (flightDetails) => {
    return flightDetails.TerminatorFlight > 0
}